export default __webpack_public_path__ + "static/media/ic_done_gray.549dd4cd.svg";